export enum Actions {
    SET_ORGANIZATIONS,
}
